import React, { useState, useEffect } from "react";
import GaugeCardAdministrator from "./GaugeCardAdministrator";
import { Card, Row, Col, Divider, Spin, Tooltip, Table } from "antd";
import _commonService from "../../../modules/commonService";
import { BarChart, Bar, XAxis, YAxis, LabelList, Cell, ResponsiveContainer } from 'recharts';
import { QuestionCircleOutlined, DashboardOutlined, DollarOutlined, LineChartOutlined } from "@ant-design/icons"
import { useParams } from "react-router-dom";
// import SummaryTermsProjectedInterest from "./SummaryTermsProjectedInterest";
import _consumerService from "../../../modules/consumerService";

const AssessmentTabForAdministrator = ({ activeKey }) => {
  const [loading, setLoading] = useState(false);
  const [assesmentInfo, setAssesmentInfo] = useState({});
  const params = useParams();
  const ApplicationObjId = params.Id;

  useEffect(() => {
    if (activeKey && activeKey == "1") {
      getApplicantAssesmentInfoByApplicationId(Number(ApplicationObjId));
    }
  }, [activeKey]);

  const getApplicantAssesmentInfoByApplicationId = async (ApplicationObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getApplicantAssesmentInfoByApplicationId(Number(ApplicationObjId));
      if (res.data) {
        let resObj = res.data.Obj;
        localStorage.setItem("ApplicantName", resObj.applicantGeneralInfoModel ? `${resObj.applicantGeneralInfoModel.FirstName || ""} ${resObj.applicantGeneralInfoModel.LastName || ""}`.trim() : "");

        setAssesmentInfo(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // Parse values for table
  const currentValueForTable = assesmentInfo && assesmentInfo.Current;
  const proFormaValueForTable = assesmentInfo && assesmentInfo.PostLoan;

  let currentPercentForTable = 'N/A', currentAmountForTable = 'N/A', proFormaPercentForTable = 'N/A', proFormaAmountForTable = 'N/A';
  if (currentValueForTable) {
    const [percent, amount] = currentValueForTable.split(', ');
    currentPercentForTable = percent ? percent.trim() : 'N/A';
    currentAmountForTable = amount ? amount.trim() : 'N/A';
  }
  if (proFormaValueForTable) {
    const [percent, amount] = proFormaValueForTable.split(', ');
    proFormaPercentForTable = percent ? percent.trim() : 'N/A';
    proFormaAmountForTable = amount ? amount.trim() : 'N/A';
  }


  // Parse values for table
  const currentValue = assesmentInfo && assesmentInfo.Current;
  const proFormaValue = assesmentInfo && assesmentInfo.PostLoan;



  // let currentPercent = 'N/A', currentAmount = 'N/A', proFormaPercent = 'N/A', proFormaAmount = 'N/A';
  // if (currentValue) {
  //   const [percent, amount] = currentValue.split(', ');
  //   currentPercent = percent ? percent.trim() : 'N/A';
  //   currentAmount = amount ? amount.trim() : 'N/A';
  // }
  // if (proFormaValue) {
  //   const [percent, amount] = proFormaValue.split(', ');
  //   proFormaPercent = percent ? percent.trim() : 'N/A';
  //   proFormaAmount = amount ? amount.trim() : 'N/A';
  // }


  // const safeLimitValue = assesmentInfo && assesmentInfo.SafeLimit;
  // const currentValue = assesmentInfo && assesmentInfo.Current;
  // const proFormaValue = assesmentInfo && assesmentInfo.PostLoan;



  // Extract numeric part before %
  // const safeLimitPercent = parseFloat(safeLimitValue && safeLimitValue.split('%')[0]);
  const currentPercent = parseFloat(currentValue && currentValue.split('%')[0]);
  const proFormaPercent = parseFloat(proFormaValue && proFormaValue.split('%')[0]);

  // Calculate difference
  // const differencePercent = safeLimitPercent - currentPercent;

  const maxValue = Math.max(currentPercent, proFormaPercent, 1);

  const barData = [
    {
      name: 'Current',
      value: currentPercent,
      // safeLimitAmount: 400000,
      color: '#93C5FD',
    },
    {
      name: 'Pro-Forma',
      // safeLimit: safeLimitPercent,
      proForma: proFormaPercent,
      // currentAmount: 105000,
      // postLoanAmount: 500000,
    }
  ];

  const currentBarData = [
    { name: 'Current', value: currentPercent }
  ];

  const proFormaBarData = [
    { name: 'Pro-Forma', value: proFormaPercent }
  ];

  const makeCenteredData = (value) => [
    {
      name: 'bar',
      leftPad: (maxValue - value) / 2,
      value,
      rightPad: (maxValue - value) / 2
    }
  ];

  return (
    <Spin spinning={loading}>

      {/* <Row gutter={[16, 16]} className="iconFont chartbox-main-wrapper gauge-card-admin-row">
        <Col
          className="gutter-row chartbox1"
          span={8}
        >
          <div style={{ width: "70%" }}>
            <GaugeCardAdministrator label="CBR Score" value={Number(assesmentInfo && assesmentInfo.CBRScore)} min={300} max={850} description={assesmentInfo && assesmentInfo.CBRScoreStaus} />
          </div>
        </Col>

        <Col
          className="gutter-row chartbox1"
          span={8}
          // gutter={[16, 16]}
        >
          <div style={{ width: "70%" }}>
            <GaugeCardAdministrator label="TDSR %" value={assesmentInfo && assesmentInfo.PFTDSR ? assesmentInfo.PFTDSR : "N/A"} min={0} max={100} unit=" %" description={assesmentInfo && assesmentInfo.TDSRStatus} />

          </div>
        </Col>

        <Col
          className="gutter-row chartbox1"
          span={8}
        >
         <div style={{ width: "70%" }}>
            <GaugeCardAdministrator label="Leverage" value={assesmentInfo && assesmentInfo.Levrage ? assesmentInfo.Levrage : "N/A"} min={0} max={2} description={assesmentInfo && assesmentInfo.LevridgeStatus} />
          </div>
        </Col>
      </Row> */}

      <Card className="iconFont chartbox-main-wrapper threebox mb10 assessment-tab">
        <div className="chartbox-title">
          <DashboardOutlined className="chartbox-title-icon" />
          Key Metrics
        </div>

        <Row
          gutter={[16, 16]}
          justify="center"
          align="middle"
          className="metrics-row"
        >
          <Col
            xs={24}
            sm={12}
            md={8}
            className="chartbox1"
          >
            <GaugeCardAdministrator label="CBR Score" value={Number(assesmentInfo && assesmentInfo.CBRScore)} min={300} max={850} description={assesmentInfo && assesmentInfo.CBRScoreStaus} />

          </Col>

          <Col
            xs={24}
            sm={12}
            md={8}
            className="chartbox1"
          >
            <GaugeCardAdministrator label="TDSR %" value={assesmentInfo && assesmentInfo.PFTDSR ? assesmentInfo.PFTDSR : "N/A"} min={0} max={100} unit=" %" description={assesmentInfo && assesmentInfo.TDSRStatus} />

          </Col>

          <Col
            xs={24}
            sm={12}
            md={8}
            className="chartbox1"
          >
            <GaugeCardAdministrator label="Leverage" value={assesmentInfo && assesmentInfo.Levrage ? assesmentInfo.Levrage : "N/A"} min={0} max={2} description={assesmentInfo && assesmentInfo.LevridgeStatus} />

          </Col>
        </Row>
      </Card>

      <Row gutter={[12, 12]} className="iconFont assessment-tab-details">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Card className="cardViewMain cardBorderShadow">
            {/* <div className="spaceFlex">
              <LineChartOutlined className="title-icon" />
              <h3 className="chartbox-title">Debt Proforma Impact</h3>
            </div> */}

            <div className="chartbox-title">
              <LineChartOutlined className="chartbox-title-icon" />
              Debt Proforma Impact
            </div>


            {/* <BarChart
              layout="vertical"
              width={350}
              height={100}
              data={barData}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              barCategoryGap={0}
              barGap={0}
            >
              <XAxis type="number" domain={[0, 50]} hide />
              <YAxis type="category" dataKey="name" width={100} />
              <Bar stackId="a" dataKey="value" barSize={30}>
                {
                  barData && barData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color || '#00FFE0'} />
                  ))
                }
                <LabelList
                  dataKey="value"
                  position="right"
                  formatter={() => ""}
                  style={{ fill: '#000', fontWeight: 600 }}
                />
              </Bar>
              <Bar dataKey="proForma" stackId="a" barSize={30} fill="#3B28CC">
                <LabelList
                  dataKey="proForma"
                  position="right"
                  formatter={() => ""}
                  style={{ fill: '#000', fontWeight: 600 }}
                />
              </Bar>
            </BarChart> */}


            <Table
              bordered={false}
              pagination={false}
              className="transparent-table"
              columns={[
                {
                  title: 'Metric',
                  dataIndex: 'metric',
                  key: 'metric',
                  render: text => <span className="spanColor">{text}</span>,
                },
                {
                  title: 'Current',
                  dataIndex: 'current',
                  key: 'current',
                },
                {
                  title: 'Pro-Forma',
                  dataIndex: 'proForma',
                  key: 'proForma',
                },
              ]}
              dataSource={[
                {
                  key: '1',
                  metric: 'Total Debt Service ($)',
                  current: currentAmountForTable,
                  proForma: proFormaAmountForTable,
                },
                {
                  key: '2',
                  metric: 'Debt-to-Income Ratio (%)',
                  current: currentPercentForTable,
                  proForma: proFormaPercentForTable,
                },
              ]}
              showHeader={true}
              size="small"
            />
            <Row justify="center" gutter={32} className="responsivechartcontainer">

              {/* CURRENT */}
              <Col>
                <div className="chartWrapperStyle">
                  <ResponsiveContainer width="100%" height={60}>
                    <BarChart
                      data={makeCenteredData(currentPercent)}
                      layout="vertical"
                      barCategoryGap={20}
                      barGap={0}
                      margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                    >
                      <XAxis type="number" hide domain={[0, maxValue]} />
                      <YAxis type="category" hide />

                      {/* Left padding */}
                      <Bar dataKey="leftPad" stackId="a" fill="transparent" />

                      {/* Actual bar */}
                      <Bar
                        dataKey="value"
                        stackId="a"
                        barSize={14}
                        radius={[8, 8, 0, 0]}
                        fill="rgba(244, 244, 245, 0.1)"
                        height={20}
                      />

                      {/* Right padding */}
                      <Bar dataKey="rightPad" stackId="a" fill="transparent" />
                    </BarChart>
                  </ResponsiveContainer>

                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>Current</div>
                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>
                    {currentValueForTable}
                  </div>
                </div>
              </Col>


              {/* PRO-FORMA */}
              <Col>
                <div className="chartWrapperStyle">
                  <ResponsiveContainer width="100%" height={60}>
                    <BarChart data={makeCenteredData(proFormaPercent)}
                      layout="vertical"
                      barCategoryGap={20}
                      barGap={0}
                      margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                    >
                      <XAxis type="number" hide domain={[0, maxValue]} />
                      <YAxis type="category" hide />

                      <Bar dataKey="leftPad" stackId="a" fill="transparent" />

                      <Bar
                        dataKey="value"
                        stackId="a"
                        barSize={20}
                        radius={[8, 8, 0, 0]}
                        fill="rgba(234, 179, 8, 1)"
                      />

                      <Bar dataKey="rightPad" stackId="a" fill="transparent" />
                    </BarChart>
                  </ResponsiveContainer>

                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>Pro-Forma</div>
                  <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>
                    {proFormaValueForTable}
                  </div>
                </div>
              </Col>


            </Row>


          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Card
            className="cardViewMain cardBorderShadow"
            style={{ height: "100%" }}
          >
            {/* <div className="financial-header">
              <DollarOutlined className="financial-icon" />
              <span>Financial Snapshot</span>
            </div> */}

            <div className="chartbox-title">
              <DollarOutlined className="chartbox-title-icon" />
              Financial Snapshot
            </div>




            <span>Total Debt Service</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalDebtService ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalDebtService)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Total Existing Debt</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalExistingDebt ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalExistingDebt)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Total Income</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalIncome ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalIncome)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Total Assets</span><span className="fRight">{assesmentInfo && assesmentInfo.AssetsValuation ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.AssetsValuation)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Net Worth</span><span className="fRight">{assesmentInfo && assesmentInfo.NetWorth ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.NetWorth)}` : "N/A"}</span>
            <Divider className="divider" />
            <span>Debt-to-Income Ratio</span><span className="fRight">{assesmentInfo && assesmentInfo.DebtIncomeRatio ? `${assesmentInfo.DebtIncomeRatio} %` : "N/A"}</span>
          </Card>
        </Col>
      </Row>

      {/* <SummaryTermsProjectedInterest /> */}
    </Spin>
  )
};

export default AssessmentTabForAdministrator;